import React, {Component} from 'react';
import add from './add.png';
import './styles.css';

export default class Add extends Component {
    public render(): JSX.Element {
        return (
            <div className="Add">
                <img src={add} alt="add" />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Add/index.tsx